import { combineReducers } from "redux";
import { exists } from './exists';
import {timelineData} from './timelineData';
import { mapData } from './mapData';

export const journeyData = combineReducers({
    exists,
    timelineData,
    mapData
});